import {ChangeDetectionStrategy, Component, WritableSignal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {TextAreaFieldComponent} from '../../inputs/text-area-field/text-area-field.component';
import {FormsModule} from '@angular/forms';
import {ButtonComponent} from '../../buttons/button/button.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';

@Component({
    selector: "woa-order-notes-edit-page",
    templateUrl: "./order-notes-edit-page.component.html",
    styleUrl: "./order-notes-edit-page.component.scss",
    providers: [{provide: Page, useExisting: OrderNotesEditPageComponent}],
    imports: [
        ButtonComponent,
        FormsModule,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        TextAreaFieldComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderNotesEditPageComponent extends Page {
    public readonly notes: WritableSignal<string> = navParam<string>("notes");

    async confirmNotes(): Promise<void> {
        void this.dismiss({notes: this.notes()});
    }
}
